export class FormElementMembershipLevelType {
  // #region Properties

  public MembershipLevelId: number;
  public Name: string;
  public LabelText: string;
  public Visible: boolean;
  public Value: string;

  // #endregion

  public constructor() {
    this.MembershipLevelId = 0;
    this.Name = '';
    this.LabelText = '';
    this.Visible = false;
    this.Value = '';
  }
}
